import { LocationsAndTerminalSearchService } from './LocationsAndTerminalSearchService';
import { LocationsAndTerminalSearchServiceInterface } from './types';

// Фабрика сервиса
export const locationsAndTerminalSearchService: {
  (token?: string): LocationsAndTerminalSearchServiceInterface;
} = (token) => new LocationsAndTerminalSearchService(token);
